import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import formatGBP from '../../../utils/formatGBP.js';
import { checkIsCardCheckout, checkIsApplePayExpressCheckout } from '../../../utils/paymentMethod.js';
import { containerStyle, fieldsetStyle, orderTotals, orderTotalsContent } from '../styles.js';
var StubbedOrderTotals = function StubbedOrderTotals(_ref) {
  var amount = _ref.amount,
    _ref$onConfirm = _ref.onConfirm,
    onConfirm = _ref$onConfirm === void 0 ? function () {} : _ref$onConfirm,
    paymentMethodType = _ref.paymentMethodType,
    shippingAmount = _ref.shippingAmount;
  var _useMemo = useMemo(function () {
      return {
        isApplePayExpressCheckout: checkIsApplePayExpressCheckout(paymentMethodType),
        isCardCheckout: checkIsCardCheckout(paymentMethodType)
      };
    }, [paymentMethodType]),
    isApplePayExpressCheckout = _useMemo.isApplePayExpressCheckout,
    isCardCheckout = _useMemo.isCardCheckout;
  return jsxs(Fragment, {
    children: [isCardCheckout && jsx("div", {
      style: containerStyle,
      children: jsxs("fieldset", {
        style: fieldsetStyle,
        children: [jsx("legend", {
          children: "Stubbed order options:"
        }), jsx("button", {
          onClick: onConfirm,
          children: "Place order and pay"
        })]
      })
    }), jsxs("div", {
      style: orderTotals,
      children: [isApplePayExpressCheckout && jsxs("div", {
        style: orderTotalsContent,
        children: ["Delivery charge:", ' ', jsx("div", {
          children: shippingAmount ? formatGBP(shippingAmount) : 'FREE'
        })]
      }), jsxs("strong", {
        style: orderTotalsContent,
        children: ["Order total:", ' ', jsx("div", {
          children: amount ? formatGBP(amount + (shippingAmount !== null && shippingAmount !== void 0 ? shippingAmount : 0)) : '£0.00'
        })]
      })]
    })]
  });
};
export { StubbedOrderTotals as default };